import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

export const getAllContact = createAsyncThunk("admin/allContact", async ({ page, limit, filter, searchData }, { rejectWithValue }) => {
  try {
    let url = `contact-us/all?page=${page}&limit=${limit}`;
    if (filter) {
      url += `&contactFilter=${filter}`;
    }
    if (searchData) {
      url += `&search=${searchData}`;
    }
    const response = await apiInstance.get(url, { headers: authHeader() });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addContact = createAsyncThunk("admin/addContact", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`contact-us/add`, payload, { headers: authHeader() });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const editContact = createAsyncThunk("admin/editContact", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`contact-us/edit`, payload, { headers: authHeader() });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteContact = createAsyncThunk("admin/deleteContact", async (id, { rejectWithValue }) => {
  try {
    const response = await apiInstance.delete(`contact-us/delete/${id}`, { headers: authHeader() });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const initialState = {
  contactLoading: false,
};

const contactSlice = createSlice({
  name: "contactSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllContact.fulfilled, (state ,action) =>{
        state.contactData = action.payload.data;
        state.contactLoading = false;
    })
    builder.addCase(addContact.fulfilled, (state) => {
        state.contactLoading = false;
    })
    builder.addCase(editContact.fulfilled, (state) => {
        state.contactLoading = false;
    })
    builder.addCase(deleteContact.fulfilled, (state) => {
        state.contactLoading = false;
    })
  },
});

export default contactSlice.reducer;